import 'jquery';
import '../modules/block-integration.js';

jQuery(document).ready(function ($) {});
